import { ReactNode } from 'react';
import { TextBlock } from '../../../Atoms/Text';

export const BaselineFooterFrame = ({ excluded, children }: { excluded: string | null; children: ReactNode }) => (
  <div className="flex items-end justify-between gap-4 border-t border-grey-2 pt-4">
    <div>
      <TextBlock
        size="sm14"
        weight="semibold"
        color="grey8">
        In-Scope Monthly Baseline
      </TextBlock>
      {excluded && (
        <TextBlock
          size="xs"
          color="grey6">
          {excluded}
        </TextBlock>
      )}
    </div>
    <div className="text-right">{children}</div>
  </div>
);
